
import { Separator } from "@/components/ui/separator";
import { ContactInfoCard } from "@/components/contact/ContactInfoCard";
import { ContactForm } from "@/components/contact/ContactForm";
import { OfficeMap } from "@/components/contact/OfficeMap";

const Contact = () => {
  // Contact information data
  const contactInfo = {
    email: "support@fraudeye.in",
    address: "Bangalore, India",
  };

  return (
    <div className="container py-12 max-w-7xl mx-auto">
      <div className="text-center mb-10">
        <h1 className="text-3xl font-bold tracking-tight">Contact Us</h1>
        <p className="text-muted-foreground mt-3 max-w-2xl mx-auto">
          Have questions about our AI detection services? We're here to help you.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <ContactInfoCard 
          email={contactInfo.email}
          address={contactInfo.address}
        />
        <ContactForm />
      </div>

      <Separator className="my-12" />

      <OfficeMap />
    </div>
  );
};

export default Contact;
